import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import '@angular/compiler';

import { defineCustomElements, addTheme } from 'corporate-ui';
import { theme as scania } from 'scania-theme';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
defineCustomElements();
addTheme(scania);
